import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-location-branding',
    templateUrl: './location-branding.component.html',
    styleUrls: ['./location-branding.component.css'],
    standalone: false
})
export class LocationBrandingComponent implements OnInit {
  @Input() locationId!: string;

  constructor() { }

  ngOnInit(): void {
    console.log('LocationBrandingComponent initialized for location:', this.locationId);
  }
}
